export default {
    loadData(state, req) {
        let { data } = req;
        if (!data) return;
        for (let key of Object.keys(data)) state[key] = data[key];
    },
};



// WEBPACK FOOTER //
// src/store/views/projects/mutations.js